/** Concrete types of the Asset interface, as cached objects are stored. */
export const ASSET_INTERFACE_TYPENAMES = ['Site', 'Turbine', 'Blade', 'GenericAsset'];
